import React from "react";

import * as S from "./styles";

const LoginAdminLayout = ({ children }: any): JSX.Element => (
  <S.Container>
    <S.Main>{children}</S.Main>
    <S.Footer>
      <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
    </S.Footer>
  </S.Container>
);

export default LoginAdminLayout;
